// src\components\CustomLogo.tsx
import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';

const LogoWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    paddingBottom: theme.spacing(5),
}));

interface LogoProps {
    src: string;
    alt?: string;
    width?: string | number;
}

const Logo: React.FC<LogoProps> = ({ src, alt = 'Logo', width = 'auto' }) => {
    return (
        <LogoWrapper>
            <img src={src} alt={alt}  width={width} />
        </LogoWrapper>
    );
};

export default Logo;